<template>
	<div>
		<div v-if="!localTransaction">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;border:1px solid #000;padding:3px;font-size: 12px;" v-else>
			<div style="font-size: 18px;text-align: center;padding: 3px 0;">{{ businessTitle }}</div>
			<div style="display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #000;padding-bottom: 3px;">
				<div style="font-size: 14px;">رسید تراکنش واریز/برداشت</div>
				<div style="font-size: 11px;">
					تاریخ چاپ: <span style="padding: 2px;border-bottom: 1px dotted #000;">{{ printDate }}</span>
				</div>
			</div>

			<table style="border-collapse: collapse;width: 100%;margin-top: 7px;border:1px solid #000;">
				<tbody>
					<tr>
						<td colspan="4" style="text-align: center;background-color: #eaeaea;font-weight: bold;padding: 3px;border-bottom: 1px solid #000;-webkit-print-color-adjust: exact; print-color-adjust: exact;">
							مشخصات تراکنش
						</td>
					</tr>
					<tr>
						<td style="padding: 3px;border: 1px solid #000;width: 20%;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">کد تراکنش</td>
						<td style="padding: 3px;border: 1px solid #000;width: 30%;text-align: center;">{{ code }}</td>
						<td style="padding: 3px;border: 1px solid #000;width: 20%;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">درگاه پرداخت</td>
						<td style="padding: 3px;border: 1px solid #000;width: 30%;text-align: center;">{{ localTransaction.onlinePaymentGatewayText }}</td>
					</tr>
					<tr>
						<td style="padding: 3px;border: 1px solid #000;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">نوع تراکنش</td>
						<td style="padding: 3px;border: 1px solid #000;text-align: center;">{{ memberPurchaseTypeText }}</td>
						<td style="padding: 3px;border: 1px solid #000;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">مبلغ</td>
						<td style="padding: 3px;border: 1px solid #000;text-align: center;">{{ amountText }}</td>
					</tr>
					<tr>
						<td style="padding: 3px;border: 1px solid #000;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">تاریخ و ساعت</td>
						<td style="padding: 3px;border: 1px solid #000;text-align: center;">&lrm;{{ dateText }} - {{ timeText }}</td>
						<td style="padding: 3px;border: 1px solid #000;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">شماره پیگیری</td>
						<td style="padding: 3px;border: 1px solid #000;text-align: center;">{{ transactionCodeText }}</td>
					</tr>
					<tr>
						<td style="padding: 3px;border: 1px solid #000;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">وضعیت پرداخت</td>
						<td colspan="3" style="padding: 3px;border: 1px solid #000;text-align: center;font-weight: bold;" :style="{ color: localTransaction.isPaymentSuccess ? '#000' : '#f44336' }">
							{{ localTransaction.isPaymentSuccess ? 'موفق' : 'ناموفق' }}
						</td>
					</tr>
				</tbody>
			</table>

			<table v-if="user" style="border-collapse: collapse;width: 100%;margin-top: 10px;border:1px solid #000;">
				<tbody>
					<tr>
						<td colspan="4" style="text-align: center;background-color: #eaeaea;font-weight: bold;padding: 3px;border-bottom: 1px solid #000;-webkit-print-color-adjust: exact; print-color-adjust: exact;">
							مشخصات پرداخت کننده
						</td>
					</tr>
					<tr>
						<td style="padding: 3px;border: 1px solid #000;width: 20%;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">نام و نام خانوادگی</td>
						<td style="padding: 3px;border: 1px solid #000;width: 30%;text-align: center;">{{ user.fullName }}</td>
						<td style="padding: 3px;border: 1px solid #000;width: 20%;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">موبایل</td>
						<td style="padding: 3px;border: 1px solid #000;width: 30%;text-align: center;">&lrm;{{ mobileText }}</td>
					</tr>
				</tbody>
			</table>

			<div style="font-weight: bold;text-align: center;padding: 3px 0;margin-top: 10px;background-color: #eaeaea;border:1px solid #000;-webkit-print-color-adjust: exact; print-color-adjust: exact;">
				جزئیات درگاه پرداخت
			</div>
			<div style="display: flex;flex-wrap: wrap;width: 100%;border:1px solid #000;">
				<div v-for="detail in gatewayDetails" :key="detail.title" style="display: flex;">
					<div style="padding: 3px;border: 1px solid #000;text-align: center;background-color: #f5f5f5;-webkit-print-color-adjust: exact; print-color-adjust: exact;">{{ detail.title }}</div>
					<div style="padding: 3px;border: 1px solid #000;text-align: center;">&lrm;{{ detail.value }}</div>
				</div>
			</div>

			<div v-if="localTransaction.description">
				<div style="font-weight: bold;text-align: center;padding: 3px 0;margin-top: 7px;background-color: #eaeaea;border:1px solid #000;-webkit-print-color-adjust: exact; print-color-adjust: exact;">
					توضیحات
				</div>
				<div style="border:1px solid #000;border-top: none;padding: 5px;text-align: right;min-height: 30px;">
					{{ localTransaction.description }}
				</div>
			</div>

			<div style="display: flex;margin-top: 40px;">
				<div style="width: 50%;padding: 10px 0;text-align: center;">
					امضا و مهر دریافت کننده
				</div>
				<div style="width: 50%;padding: 10px 0;text-align: center;border-right: 1px dashed #000;">
					امضا و مهر پرداخت کننده
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { get } from 'vuex-pathify'
import { cloneDeep } from 'lodash'

export default {
	name: 'ArvandGatewayTransactionsPrintHtml',
	components: {
	},
	props: {
		transaction: {
			type: Object,
		},
		area: {
			type: String,
			default: 'admin'
		}
	},
	data: () => ({
		localTransaction: null,
	}),
	mounted() {
		this.fillHtml()
	},
	computed: {
		...get('siteConfig', [
			'fullTitle'
		]),
		...get('appSettings', [
			'settings'
		]),
		...get('auth', [
			'getCurrentUser',
		]),
		businessTitle() {
			return this.area === 'agent' ? this.getCurrentUser?.userData?.businessName : this.settings?.businessTitle || this.fullTitle || ''
		},
		printDate() {
			return new Date().toLocaleDateString('fa-IR').toString().toPersianDigits()
		},
		user() {
			return this.localTransaction.user
		},
		code() {
			return (this.localTransaction.code || '').toString().toPersianDigits()
		},
		amountText() {
			return this.localTransaction.amount.toString().toPriceFormat().toPersianDigits() + ' تومان'
		},
		dateText() {
			return (this.localTransaction.startDate_Persian?.date || '').toString().toPersianDigits()
		},
		timeText() {
			return (this.localTransaction.startDate_Persian?.time || '').toString().toPersianDigits()
		},
		mobileText() {
			return (this.user.mobile || '').toString().toPersianDigits()
		},
		transactionCodeText() {
			return this.getTransactionCode().toString().toPersianDigits()
		},
		memberPurchaseTypeText() {
			switch (this.localTransaction.memberPurchaseType) {
				case 0:
					return 'واریز قسط'
				case 1:
					return 'شارژ کیف پول'
				case 2:
					return 'برداشت از کیف پول'
				case 3:
					return 'شارژ دستی کیف پول'
				case 4:
					return 'صورتحساب الکترونیکی'
				case 5:
					return 'تسویه وام'
				default:
					return 'نامشخص'
			}
		},
		gatewayDetails() {
			const purchase = this.localTransaction
			switch (purchase.onlinePaymentGateway) {
				case 1:
					return [
						{ title: 'شماره پیگیری', value: purchase.zarinPalPurchase?.refId },
						{ title: 'کد مجوز', value: purchase.zarinPalPurchase?.authority },
						{ title: 'نتیجه وریفای', value: purchase.zarinPalPurchase?.verifyStatus },
					].filter(x => x.value != null && x.value !== '')
				case 3:
					return [
						{ title: 'شماره ترمینال', value: purchase.sepPurchase?.terminalId },
						{ title: 'نتیجه', value: purchase.sepPurchase?.state },
						{ title: 'وضعیت', value: purchase.sepPurchase?.status },
						{ title: 'نتیجه وریفای', value: purchase.sepPurchase?.verifyResultDescription },
						{ title: 'شماره مرجع', value: purchase.sepPurchase?.refNum },
						{ title: 'شماره رهگیری', value: purchase.sepPurchase?.traceNo },
					].filter(x => x.value != null && x.value !== '')
				case 5:
					return [
						{ title: 'شماره ترمینال', value: purchase.ipgParsianPurchase?.terminalNo },
						{ title: 'شماره سفارش', value: purchase.ipgParsianPurchase?.orderId },
						{ title: 'شماره پیگیری', value: purchase.ipgParsianPurchase?.rrn },
						{ title: 'وضعیت', value: purchase.ipgParsianPurchase?.status },
						{ title: 'نتیجه وریفای', value: purchase.ipgParsianPurchase?.verifyStatus },
					].filter(x => x.value != null && x.value !== '')
				case 6:
					return [
						{ title: 'شماره ترمینال', value: purchase.sadadPurchase?.terminalId },
						{ title: 'شماره مرجع تراکنش', value: purchase.sadadPurchase?.retrivalRefNo },
						{ title: 'شماره پیگیری', value: purchase.sadadPurchase?.systemTraceNo },
						{ title: 'شماره سفارش', value: purchase.sadadPurchase?.orderId },
						{ title: 'وضعیت', value: purchase.sadadPurchase?.resCode + (purchase.sadadPurchase?.description ? ' - ' + purchase.sadadPurchase.description : '') },
					].filter(x => x.value != null && x.value !== '')
				case 7:
					return [
						{ title: 'شماره ترمینال', value: purchase.sepehrPurchase?.terminalId },
						{ title: 'شماره پیگیری', value: purchase.sepehrPurchase?.tracenumber },
						{ title: 'شماره مرجع', value: purchase.sepehrPurchase?.rrn },
						{ title: 'شماره سفارش', value: purchase.sepehrPurchase?.invoiceId },
						{ title: 'وضعیت', value: purchase.sepehrPurchase?.respmsg },
						{ title: 'نتیجه وریفای', value: purchase.sepehrPurchase?.verifyMessage },
					].filter(x => x.value != null && x.value !== '')
				default:
					return []
			}
		},
	},
	methods: {
		fillHtml() {
			this.localTransaction = cloneDeep(this.transaction)
			this.$nextTick(() => {
				this.$emit('ready')
			})
		},
		getTransactionCode() {
			const purchase = this.localTransaction
			switch (purchase.onlinePaymentGateway) {
				case 1:
					return purchase.zarinPalPurchase?.refId || purchase.code
				case 3:
					return purchase.sepPurchase?.refNum || purchase.code
				case 5:
					return purchase.ipgParsianPurchase?.rrn || purchase.code
				case 6:
					return purchase.sadadPurchase?.retrivalRefNo || purchase.code
				case 7:
					return purchase.sepehrPurchase?.tracenumber || purchase.code
				default:
					return purchase.code
			}
		},
	}
}
</script>
<style scoped></style>